import axios from 'axios'
import { Message, Loading } from 'element-ui'
import Common from './common'
import { getToken, setToken } from './auth'
import store from '../store'
import Vue from 'vue'
import router from '../router';

const service = axios.create({
  baseURL: Common.urlPrefix,
  timeout: 100000
}
);
// request interceptor   请求拦截器
service.interceptors.request.use(
  config => {
    if (getToken()) {
      config.headers['token'] = getToken() // 让每个请求携带token
    } else {
      // 雪花算法生成token
      setToken("$" + Common.snowflakeId);
      config.headers['token'] = getToken()
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
);

// response interceptor   返回拦截器
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    // console.log(response.config.name) //接口名称
    //code==201 自己处理错误信息
    if (response.data.code === 0 || response.data.code === 201) {
      return response.data;
    }
    else {
      // 非法访问，退出登录，重定向到登录页
      if([1,2,5,6,11].indexOf(response.data.code) > -1) {
        store.dispatch('logout', this.ruleForm).then(() => {
          window.location.href = "/static/login.html";
        })
      }

      else if (response.data.code === 10) {
        Vue.prototype.eventBus.$emit('changeImgVerificationCode','login');
      }

      return Promise.reject(response.data.message)
    }
  },
  error => {
    // Message({
    //   message: "axios请求发生错误：" + error,
    //   type: 'error',
    //   duration: 5 * 1000
    // });
    return Promise.reject(error)
  }
);

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js